/*
 * usePruneRemovedRouteSelection
 *
 * A DB route leaving the RouteStore (route or voyage delete, any caller)
 * leaves the tree selection too, so the table never shows a card for a route
 * that no longer exists. Only removals count: a selected id the store has not
 * loaded yet stays selected.
 */

import { useEffect, useRef } from "react";
import { useRouteStore } from "@/features/route/state/RouteStore.jsx";
import { treeSelectionActions } from "@/features/routeTree/state/VesselTreeState.jsx";

export default function usePruneRemovedRouteSelection({
  selectedRouteIds,
  treeDispatch,
}) {
  const { state } = useRouteStore();
  const routesById = state.entities.routesById;
  const knownIdsRef = useRef(new Set());

  useEffect(() => {
    const known = knownIdsRef.current;
    const current = new Set(Object.keys(routesById ?? {}).map(Number));
    knownIdsRef.current = current;
    for (const selectionId of selectedRouteIds ?? []) {
      const id = Number(selectionId);
      if (id > 0 && known.has(id) && !current.has(id)) {
        treeDispatch(treeSelectionActions.deselectRoute(selectionId));
      }
    }
  }, [routesById, selectedRouteIds, treeDispatch]);
}
